import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-70" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "12px"
    }} data-id="element-71" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black text-plum" data-id="element-72" data-mp="32lrn9grlb3lk">
          COREANO EXPRESSO<span className="align-super text-xs" data-id="element-73" data-mp="36ppktn19o6ci">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-74" data-mp="3ug3etj3ewf9q">
          Il metodo visivo per imparare il coreano da zero: Hangeul, pronuncia, frasi reali ed
          espressioni dei K-Drama / K-Pop in 60 minuti. Perché amare la cultura coreana non deve
          significare dipendere dai sottotitoli per sempre.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-75" data-mp="3qfjey7rgexjw">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-76" data-mp="2ey9zdwbg4pnv">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-77" data-mp="3la2a6wqof7wa" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-78" data-mp="3gbqx8d534h9u">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-79" data-mp="3v5n7ihksvjzp" /> @sigmasmartitaliano
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-80" data-mp="3qazrz87rxzx9">
          🌸 « 안녕하세요 — La tua prima parola coreana inizia oggi. »
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-81" data-mp="335trjf5jnhj">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-82" data-mp="hrihjt43600y">
            Termini di Utilizzo
          </a>
          <span data-id="element-83" data-mp="cw3595lq8c6n">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-84" data-mp="qt8flhsh3x7p">
            Politica sulla Privacy
          </a>
          <span data-id="element-85" data-mp="mthk50s04swu">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-86" data-mp="mptr02qgy8in">
            Supporto
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-87" data-mp="ytoa64vnsjyf">
          © 2026 COREANO EXPRESSO™ — SIGMA SMART™ — Tutti i diritti riservati. Riproduzione e
          redistribuzione vietate senza autorizzazione espressa.
        </p>
      </div>
    </footer>;
}